export default "__VITE_ASSET__e4de286d__"